<template>
  <vx-card class="my-2">
    <form-wizard :subtitle="null" :title="null" @on-complete="formSubmitted" color="rgba(var(--vs-primary), 1)"
                 finishButtonText="Create" stepSize="sm" shape="square">

      <!-- tab 1 content -->
      <tab-content class="mb-5" title="ITS Products" :before-change="validateStep1">
        <div class="vx-row">
          <div class="vx-col w-full mt-5">
            <div class="vx-row mb-8">
              <div class="vx-col md:w-1/4 sm:w-1/2 w-full">
                <label class="text-sm opacity-100 text-bold">General</label>
                <vs-input type="search" placeholder=""
                          v-model="filters['search']" class="mb-4 md:mb-0 w-full"/>
              </div>
              <div class="vx-col md:w-1/4 sm:w-1/2 w-full">
                <label class="text-sm opacity-100 text-bold">Filter</label>
                <v-select :clearable="true" :reduce="option => option.value" label="name"
                          :options="[
                            { name: 'Last 7 Days Orders', value: 'seven_days' },
                            {name: 'Overdue Orders', value: 'overdue'},
                            {name: 'Non UK', value: 'non_uk'}
                            ]"
                          v-model="filters['filter']"/>
              </div>
            </div>

            <vs-table :data="order_formulations_list" @selected="handleSelected"
                      id="work-order-create-select-formulation-section" :sst="true"
                       v-model="selected" @sort="handleSort" :max-items="(meta.per_page) ? meta.per_page : 10">

              <template slot="thead">
                <vs-th>ITS PRODUCT CODE</vs-th>
                <vs-th>ITS PRODUCT NAME</vs-th>
                <vs-th sort-key="required-by">REQUIRED BY DATE</vs-th>
                <vs-th sort-key="shipment-date">SHIP BY DATE</vs-th>
                <vs-th>TYPE</vs-th>
                <vs-th>CUSTOMER ORDERS (Qty)</vs-th>
                <vs-th>TOTAL ORDER QUANTITY (Kg)</vs-th>
                <vs-th>MAX POSSIBLE PRODUCTION QUANTITY (Kg)</vs-th>
                <vs-th>UNALLOCATED FG STOCK (Kg)</vs-th>
                <vs-th>ACTION</vs-th>
              </template>

              <template slot-scope="{data}">
                <vs-tr :data="tr" :key="indextr" v-for="(tr, indextr) in data">

                  <vs-td :data="data[indextr].formulation_code">
                    {{ data[indextr].formulation_code }}
                  </vs-td>

                  <vs-td :data="data[indextr].name">
                    {{ data[indextr].name }}
                  </vs-td>

                  <vs-td :data="data[indextr].oldest_item_required_by">
                    {{ data[indextr].oldest_item_required_by }}
                  </vs-td>

                  <vs-td :data="data[indextr].oldest_item_shipment_date">
                    {{ data[indextr].oldest_item_shipment_date }}
                  </vs-td>

                  <vs-td :data="data[indextr].formulation_type">
                    {{ data[indextr].formulation_type }}
                  </vs-td>

                  <vs-td :data="data[indextr].number_of_customer_order">
                    {{ data[indextr].number_of_customer_order }}
                  </vs-td>

                  <vs-td :data="data[indextr].total_order_quantity">
                    {{ toFixed(data[indextr].total_order_quantity) }}
                  </vs-td>

                  <vs-td :data="data[indextr].max_products_possible">
                    {{ toFixed(data[indextr].max_products_possible) }}
                  </vs-td>

                  <vs-td>
                    {{data[indextr].formulation_stock}}
                  </vs-td>

                  <vs-td>
                    <div class="vx-row">
                      <vx-tooltip v-if="checkIfRequestedDate(data[indextr].order_items)" class="ml-2" text="Special requested date" position="left">
                        <vs-button
                          size="small" color="danger" type="filled" icon-pack="feather" icon="icon-bell"></vs-button>
                      </vx-tooltip>
                      <vx-tooltip class="ml-2" text="RM stock/Formulation stock" position="left">
                        <vs-button @click.stop="onCLickViewRmStock(data[indextr].id)"
                          size="small" color="primary" type="filled" icon-pack="feather" icon="icon-box"></vs-button>
                      </vx-tooltip>
                    </div>
                  </vs-td>

                  <template class="expand-user" slot="expand">
                    <div class="con-expand-users w-full">
                      <vs-table
                        :data="data[indextr].order_items"
                        :hoverFlat="true"
                      class="m-16">
                        <template slot="thead">
                          <vs-th width="10%" class="text-sm">ORDER DATE</vs-th>
                          <vs-th width="10%" class="text-sm">REQUIRED BY</vs-th>
                          <vs-th width="10%" class="text-sm">SHIP BY DATE</vs-th>
                          <vs-th width="20%" class="text-sm">CUSTOMER ORDER CODE</vs-th>
                          <vs-th width="20%" class="text-sm">CUSTOMER</vs-th>
                          <vs-th width="10%" class="text-sm">PENDING CUSTOMER ORDER QTY (Kg)</vs-th>
                          <vs-th width="20%" class="text-sm">ACTIONS</vs-th>
                        </template>

                        <template slot-scope="{data}">
                          <vs-tr class="text-sm" :key="index_item" v-for="(tr_item, index_item) in data">

                            <vs-td :data="tr_item.order_date">
                              {{ tr_item.order_date }}
                            </vs-td>

                            <vs-td :data="tr_item.required_by">
                              {{ tr_item.required_by || 'N/A' }}
                            </vs-td>

                            <vs-td :data="tr_item.shipment_date">
                              {{ tr_item.shipment_date || 'N/A' }}
                            </vs-td>

                            <vs-td :data="tr_item.product_order_code">
                              {{tr_item.product_order_code}}
                            </vs-td>

                            <vs-td :data="tr_item.company_name">
                              {{tr_item.company_name}}
                            </vs-td>

                            <vs-td :data="tr_item.pending_manufacture_quantity">
                              {{ toFixed(tr_item.pending_manufacture_quantity) }}
                            </vs-td>

                            <vs-td >
<!--                              <div class="vx-row" v-if="checkFgStockAvailable(tr_item.pending_manufacture_quantity, tr.formulation_stock)">-->
                              <div class="vx-row">
                                <vx-tooltip v-if="Number(tr.no_formulation_stock_items) > 0" class="ml-2" text="Allocate from FG stock" position="left">
                                  <vs-button
                                             @click="onClickStockAssign(tr.formulation_stock_items, tr.id, tr_item.id)"
                                             size="small" color="primary" type="filled" icon-pack="feather" icon="icon-archive"></vs-button>
                                </vx-tooltip>
                                <vx-tooltip v-if="tr_item.requested_date" class="ml-2" text="Special requested date" position="left">
                                  <vs-button
                                    size="small" color="danger" type="filled" icon-pack="feather" icon="icon-bell"></vs-button>
                                </vx-tooltip>
                              </div>
                            </vs-td>

                          </vs-tr>
                        </template>
                      </vs-table>
                    </div>
                  </template>
                </vs-tr>
              </template>

            </vs-table>
<!--            <vs-pagination :total="(meta.last_page)? meta.last_page : 0" v-model="page" class="p-5"></vs-pagination>-->
            <vx-pagination
              v-on:changeMaxItems="changePage"
              :size-array="meta.total ? meta.total : 20"
              :max-items="perPage"
              description-body="Rows per page"
              description-connector="of"
              description-title="Records"
              description
              :description-items="descriptionItems"
              :total="(meta.last_page)? meta.last_page : 0"
              v-model="page"  class="p-5">
            </vx-pagination>
          </div>
        </div>
      </tab-content>

      <!-- tab 2 content -->
      <tab-content class="mb-5" title="Item Quantity and Production Line" :before-change="validateStep2">

        <div class="vx-row md:mb-16 mt-8">
          <div class="vx-col md:w-1/6 w-full">
            <vs-row vs-type="flex w-full" class="w-full">
              <vs-col
                vs-type="flex" vs-justify="center" vs-align="start" vs-w="2">
                <feather-icon icon="InfoIcon" class="text-success cursor-pointer"/>
              </vs-col>
              <vs-col
                vs-type="flex" vs-justify="start" vs-align="start" vs-w="10">
                  <span class="text-md">
                    <h6 class="mb-2">ITS Product Code</h6>
                    <small class="text-primary font-bold">{{selected.formulation_code}}</small>
                  </span>
              </vs-col>
            </vs-row>
          </div>
          <div class="vx-col md:w-1/6 w-full">
            <vs-row vs-type="flex w-full" class="w-full">
              <vs-col
                vs-type="flex" vs-justify="center" vs-align="start" vs-w="2">
                <feather-icon icon="InfoIcon" class="text-success cursor-pointer"/>
              </vs-col>
              <vs-col
                vs-type="flex" vs-justify="start" vs-align="start" vs-w="10">
                  <span class="text-md">
                    <h6 class="mb-2">ITS Product Name</h6>
                    <small class="text-primary font-bold">{{selected.name}}</small> <br>
                    <small class="text-xs">({{selected.formulation_type}})</small>
                  </span>
              </vs-col>
            </vs-row>
          </div>
          <div class="vx-col md:w-1/6 w-full">
            <vs-row vs-type="flex w-full" class="w-full">
              <vs-col
                vs-type="flex" vs-justify="center" vs-align="start" vs-w="2">
                <feather-icon icon="InfoIcon" class="text-success cursor-pointer"/>
              </vs-col>
              <vs-col
                vs-type="flex" vs-justify="start" vs-align="start" vs-w="10">
                  <span class="text-md">
                    <h6 class="mb-2">No of Customer Order (Qty)</h6>
                    <small class="text-primary font-bold">{{selected.number_of_customer_order}}</small>
                  </span>
              </vs-col>
            </vs-row>
          </div>
          <div class="vx-col md:w-1/6 w-full">
            <vs-row vs-type="flex w-full" class="w-full">
              <vs-col
                vs-type="flex" vs-justify="center" vs-align="start" vs-w="2">
                <feather-icon icon="InfoIcon" class="text-success cursor-pointer"/>
              </vs-col>
              <vs-col
                vs-type="flex" vs-justify="start" vs-align="start" vs-w="10">
                  <span class="text-md">
                    <h6 class="mb-2">Total Order Qty (Kg)</h6>
                    <small class="text-primary font-bold">{{toFixed(selected.total_order_quantity)}}</small>
                  </span>
              </vs-col>
            </vs-row>
          </div>
          <div class="vx-col md:w-1/6 w-full">
            <vs-row vs-type="flex w-full" class="w-full">
              <vs-col
                vs-type="flex" vs-justify="center" vs-align="start" vs-w="2">
                <feather-icon icon="InfoIcon" class="text-success cursor-pointer"/>
              </vs-col>
              <vs-col
                vs-type="flex" vs-justify="start" vs-align="start" vs-w="10">
                  <span class="text-md">
                    <h6 class="mb-2">Max Product Possible (Kg)</h6>
                    <small class="text-primary font-bold">{{toFixed(selected.max_products_possible)}}</small>
                  </span>
              </vs-col>
            </vs-row>
          </div>
          <div class="vx-col md:w-1/6 w-full">
            <vs-row vs-type="flex w-full" class="w-full">
              <vs-col
                vs-type="flex" vs-justify="center" vs-align="start" vs-w="2">
                <feather-icon icon="InfoIcon" class="text-success cursor-pointer"/>
              </vs-col>
              <vs-col
                vs-type="flex" vs-justify="start" vs-align="start" vs-w="10">
                  <span class="text-md">
                    <h6 class="mb-2">FG Stock (Kg)</h6>
                    <small class="text-primary font-bold">{{toFixed(selected.formulation_stock)}}</small>
                  </span>
              </vs-col>
            </vs-row>
          </div>
        </div>

        <div class="vx-row md:mb-3 mt-16">
          <div class="vx-col w-full">
            <h5 class="mb-4" style="color: #626262">Customer orders not yet in manufacturing plan</h5>
            <vs-table
              :data="order_formulations_items"
              :hoverFlat="true">

              <template slot="thead">
                <vs-th width="10%" class="text-xs">ORDER DATE</vs-th>
                <vs-th width="10%" class="text-xs">CUSTOMER ORDER CODE</vs-th>
                <vs-th width="10%" class="text-xs">SHIP BY DATE</vs-th>
                <vs-th width="10%" class="text-xs">CUSTOMER NAME</vs-th>
                <vs-th width="15%" class="text-xs">PENDING MANUFACTURING QTY (Kg)</vs-th>
                <vs-th width="15%" class="text-xs">PENDING MANUFACTURING QTY (Ltr)</vs-th>
                <vs-th width="15%" class="text-xs">SELECTED QTY Kg</vs-th>
                <vs-th width="15%" class="text-xs">SELECTED QTY Ltr</vs-th>
              </template>

              <template slot-scope="{data}">
                <vs-tr class="text-sm" :data="tr" :key="indextr" v-for="(tr, indextr) in data">

                  <vs-td :data="data[indextr].order_date">
                    {{ data[indextr].order_date }}
                  </vs-td>

                  <vs-td :data="data[indextr].product_order_code">
                    {{ data[indextr].product_order_code }}
                  </vs-td>

                  <vs-td :data="data[indextr].product_order_code">
                    {{ data[indextr].shipment_date || 'N/A' }}
                  </vs-td>

                  <vs-td :data="data[indextr].company_name">
                    {{ data[indextr].company_name }}
                  </vs-td>

                  <vs-td :data="data[indextr].pending_manufacture_quantity">
                    {{ toFixed(data[indextr].pending_manufacture_quantity) }}
                  </vs-td>

                  <vs-td :data="data[indextr].pending_manufacture_quantity">
                    {{ toFixed(Number(data[indextr].pending_manufacture_quantity) * Number(selected.formulation_per_lt)) }}
                  </vs-td>

                  <vs-td :data="data[indextr].pending_manufacture_quantity">
                    <!--                  <vs-row class="flex">-->
                    <ValidationProvider :name="indextr + 'quantity'"
                                        :rules="'maxoq:'+ data[indextr].pending_manufacture_quantity"
                                        :vid="indextr + 'quantity'"
                                        v-slot="{ errors }">
                      <vs-input-number
                        v-on:input="handleSelectedProductionLine()"
                        class="bg-white"
                        :max="data[indextr].pending_manufacture_quantity"
                        min="0" v-model="data[indextr].quantity"/>
                    </ValidationProvider>
                    <!--                  </vs-row>-->
                  </vs-td>

                  <vs-td :data="data[indextr].pending_manufacture_quantity">
                    {{ toFixed(Number(data[indextr].quantity) * Number(selected.formulation_per_lt)) }}
                  </vs-td>

                </vs-tr>
                <vs-tr class="font-bold">
                  <vs-td>Total</vs-td>
                  <vs-td></vs-td>
                  <vs-td></vs-td>
                  <vs-td></vs-td>
                  <vs-td>{{totalPendingManufacturingQuantityKilo}}</vs-td>
                  <vs-td>{{totalPendingManufacturingQuantityLiter}}</vs-td>
                  <vs-td>{{totalSelectedQuantityKilo}}</vs-td>
                  <vs-td>{{totalSelectedQuantityLiter}}</vs-td>
                </vs-tr>
                <vs-tr class="font-bold">
                  <vs-td></vs-td>
                  <vs-td></vs-td>
                  <vs-td></vs-td>
                  <vs-td></vs-td>
                  <vs-td></vs-td>
                  <vs-td class="text-xs">Remaining Capacity</vs-td>
                  <vs-td>{{remainingQuantityKilo}}</vs-td>
                  <vs-td>{{remainingQuantityLiter}}</vs-td>
                </vs-tr>

              </template>
            </vs-table>
          </div>
        </div>

        <div class="vx-row">
          <div class="vx-col w:md-1/3">
            <label>Would like to make surplus product for your finished good inventory?</label>
            <vs-switch v-model="is_add_unallocated_quantity" class="mt-4"/>
          </div>
          <div class="vx-col w:md-1/3" v-if="is_add_unallocated_quantity">
            <small class="label">Please select the amount in KG that you wish to make.</small>
            <vs-input :max="remainingQuantityKilo" type="number" v-model="unallocated_quantity"  name="unallocated_quantity" class="w-full required mt-2" label=""/>
          </div>
        </div>


        <div class="vx-row md:mb-3 mt-8">
          <div class="vx-col w-full">
            <h5 class="mb-4" style="color: #626262">Select Production Line</h5>
            <vs-table :data="production_lines" @selected="handleSelectedProductionLine" v-model="selected_production_line">

              <template slot="thead">
                <vs-th width="20%" class="text-sm">PRODUCTION LINE CODE</vs-th>
                <vs-th width="20%" class="text-sm">NAME</vs-th>
                <vs-th class="text-sm">TYPE</vs-th>
                <vs-th class="text-sm">MAX CAPACITY (KG)</vs-th>
                <vs-th class="text-sm">MAX CAPACITY (L)</vs-th>
                <vs-th width="10%"></vs-th>
              </template>

              <template slot-scope="{data}">
                <vs-tr class="text-sm" :data="tr" :key="indextr" v-for="(tr, indextr) in data">

                  <vs-td :data="data[indextr].production_line_code">
                    {{ data[indextr].production_line_code}}
                  </vs-td>

                  <vs-td :data="data[indextr].production_line_name">
                    {{ data[indextr].production_line_name }}
                  </vs-td>

                  <vs-td :data="data[indextr].type">
                    {{ data[indextr].type }}
                  </vs-td>

                  <vs-td :data="data[indextr].max_capacity_kg">
                    {{ toFixed(data[indextr].max_capacity_kg) }}
                  </vs-td>

                  <vs-td :data="data[indextr].max_capacity_ltr">
                    {{ toFixed(data[indextr].max_capacity_ltr) }}
                  </vs-td>

                  <vs-td >
                    <vs-chip style="border-radius: 0" color="success" v-if="data[indextr].id === selected_production_line.id">
                      selected
                    </vs-chip>
                  </vs-td>

                </vs-tr>
              </template>

            </vs-table>
          </div>
        </div>

                <div class="vx-row mt-8 mb-8" v-if="Number(selected.formulation_stock) > 0">
                  <div class="vx-col w:md-1/3">
                    <label>Do you want re-blend with unallocated FG stock?</label>
                    <vs-switch v-model="is_reblended" class="mt-4"/>
                  </div>
                </div>

        <div class="vx-row md:mb-8 mt-8" v-if="Number(selected.no_formulation_stock_items) > 0 && is_reblended">
          <div class="vx-col w-full">
            <h5 class="mb-4" style="color: #626262">FG stock for reblending</h5>
            <vs-table
              v-model="re_blend_inventory"
              :onlyClickCheckbox="true"
              multiple
              @selected="handleReBlendStock"
              :data="selected.formulation_stock_items"
              :hoverFlat="true"
              id="assign-formulation-stock-inventory-pop-up"
              stripe>

              <template slot="thead">
                <vs-th width="20%"  class="text-sm" sort-key="sundry_item_code">BATCH CODE</vs-th>
                <vs-th width="10%"  class="text-xs">MANUFACTURE DATE</vs-th>
                <vs-th width="10%"  class="text-xs">EXP DATE</vs-th>
                <vs-th width="10%"  class="text-xs">MLOR %</vs-th>
                <vs-th width="10%" class="text-xs">BATCH QTY (KG)</vs-th>
                <vs-th width="10%" class="text-xs">COMPLETED/AVAILABLE QTY (KG)</vs-th>
                <vs-th width="20%" class="text-xs">STATUS</vs-th>
                <vs-th width="10%" class="text-xs">Quantity (Kg) to reblend</vs-th>
              </template>

              <template slot-scope="{data}">
                <vs-tr :data="tr" :key="indextr" v-for="(tr, indextr) in data">

                  <vs-td class="text-sm text-primary font-semibold" :data="data[indextr].work_order_code">
                    {{ data[indextr].work_order_code}}
                  </vs-td>

                  <vs-td class="text-sm" :data="data[indextr].manufacture_date">
                    {{ data[indextr].manufacture_date}}
                  </vs-td>

                  <vs-td class="text-sm" :data="data[indextr].expiration_date">
                    {{ data[indextr].expiration_date}}
                  </vs-td>

                  <vs-td class="text-sm" :data="data[indextr].mlor">
                    {{ data[indextr].mlor}}
                  </vs-td>

                  <vs-td class="text-sm" :data="data[indextr].total_quantity">
                    {{ toFixed(data[indextr].total_quantity)}}
                  </vs-td>


                  <vs-td class="text-sm" :data="data[indextr].completed_quantity">
                    {{ toFixed(data[indextr].completed_quantity)}}
                  </vs-td>

                  <vs-td class="text-sm" :data="data[indextr].status">
                    <vs-chip transparent :color="'dark'" style="border-radius: 0" class="w-32">
                      {{ data[indextr].status}}
                    </vs-chip>
                  </vs-td>

                  <vs-td>
                    <div class="vx-row">
                      <vs-input v-on:input="onInputReBlendInventory(indextr)" v-if="data[indextr].status === 'In_Stock'" v-model="data[indextr].quantity" class="w-full required" />
                    </div>
                  </vs-td>

                </vs-tr>
              </template>
            </vs-table>
          </div>
        </div>

<!--        <div class="vx-row mt-8" v-if="Number(selected.formulation_stock) > 0">-->
<!--          <div class="vx-col w:md-1/3">-->
<!--            <label>Re-blend with unallocated FG stock?</label>-->
<!--            <vs-switch v-on:input="onChangeReBlend()" v-model="is_reblended" class="mt-4"/>-->
<!--          </div>-->
<!--        </div>-->
<!--        <div v-if="is_reblended" class="vx-row mt-4">-->
<!--          <div class="vx-col md:w-1/3 w-full">-->
<!--            <vs-table-->
<!--              :data="re_blend_inventory"-->
<!--              class="table-dark-inverted table-auto vs-con-loading__container">-->

<!--              <template slot="thead">-->
<!--                <vs-th width="15%" class="text-xs">BATCH CODE</vs-th>-->
<!--                <vs-th width="10%" class="text-xs">QUANTITY (KG)</vs-th>-->
<!--              </template>-->

<!--              <template slot-scope="{data}">-->
<!--                <vs-tr @click="onChangeReBlend()" class="text-sm" style="cursor: pointer"  :key="indextr" v-for="(tr, indextr) in data">-->

<!--                  <vs-td :data="data[indextr].work_order">-->
<!--                    {{ data[indextr].work_order}}-->
<!--                  </vs-td>-->
<!--                  <vs-td :data="data[indextr].quantity">-->
<!--                    {{ toFixed(data[indextr].quantity) }}-->
<!--                  </vs-td>-->
<!--                </vs-tr>-->
<!--                <vs-tr>-->
<!--                  <vs-td>Total</vs-td>-->
<!--                  <vs-td>{{toFixed(totalReBlendQuantity)}}</vs-td>-->
<!--                </vs-tr>-->
<!--              </template>-->
<!--            </vs-table>-->
<!--          </div>-->
<!--        </div>-->

        <div class="flex flex-wrap items-center justify-end mt-8">
          <h6 class="break-all">Remaining Production Line Capacity (Kg) : {{ remainingProductionLineCapacity }}</h6>
        </div>
        <div class="flex flex-wrap items-center justify-end mt-8">
          <h5 class="break-all">Total quantity to manufacture (Kg) : {{totalQuantityToManufacture}}</h5>
        </div>

      </tab-content>

      <!-- tab 3 content -->
      <tab-content class="mb-5" title="Summary">
        <div class="vx-row" id="work-order-create-section">
          <div class="vx-col md:w-1/3 w-full">
            <h5 class="mb-2" style="color: #626262">Finished Product</h5>
            <div class="vx-row mt-0">
              <div class="vx-col lg:w-full w-full">
                <vs-table noDataText="">
                  <template>
                    <vs-tr>
                      <vs-td class="">ITS Product Code</vs-td>
                      <vs-td class="font-bold text-primary">{{selected.formulation_code}}</vs-td>
                    </vs-tr>
                    <vs-tr>
                      <vs-td class="">ITS Product Name</vs-td>
                      <vs-td class="font-bold text-primary">{{selected.name}}</vs-td>
                    </vs-tr>
                    <vs-tr>
                      <vs-td class="">Type</vs-td>
                      <vs-td class="font-bold text-primary">{{selected.formulation_type}}</vs-td>
                    </vs-tr>
                    <vs-tr>
                      <vs-td class="">Customer Orders (Qty)</vs-td>
                      <vs-td class="font-bold text-primary">{{numberOfSelectedCustomerOrders}}</vs-td>
                    </vs-tr>
                    <vs-tr>
                      <vs-td class="">Total Order Qty (Kg)</vs-td>
                      <vs-td class="font-bold text-primary">{{toFixed(totalSelectedQuantityKilo)}}</vs-td>
                    </vs-tr>
                    <vs-tr>
                      <vs-td class="">Max Products Possible (Kg)</vs-td>
                      <vs-td class="font-bold text-primary">{{toFixed(selected.max_products_possible)}}</vs-td>
                    </vs-tr>
                  </template>
                </vs-table>
              </div>
            </div>
          </div>
          <div class="vx-col md:w-1/3 w-full">
            <h5 class="mb-2" style="color: #626262">Production Line</h5>
            <div class="vx-row mt-0">
              <div class="vx-col lg:w-full w-full">
                <vs-table noDataText="">
                  <template>
                    <vs-tr>
                      <vs-td class="">Production Line Code</vs-td>
                      <vs-td class="font-bold text-primary">{{selected_production_line.production_line_code}}</vs-td>
                    </vs-tr>
                    <vs-tr>
                      <vs-td class="">Production Line Name</vs-td>
                      <vs-td class="font-bold text-primary">{{selected_production_line.production_line_name}}</vs-td>
                    </vs-tr>
                    <vs-tr>
                      <vs-td class="">Type</vs-td>
                      <vs-td class="font-bold text-primary">{{selected_production_line.type}}</vs-td>
                    </vs-tr>
                    <vs-tr>
                      <vs-td class="">Max Capacity Kg</vs-td>
                      <vs-td class="font-bold text-primary">{{toFixed(selected_production_line.max_capacity_kg)}}</vs-td>
                    </vs-tr>
                    <vs-tr>
                      <vs-td class="">Max Capacity L</vs-td>
                      <vs-td class="font-bold text-primary">{{toFixed(selected_production_line.max_capacity_ltr)}}</vs-td>
                    </vs-tr>
                  </template>
                </vs-table>
              </div>
            </div>
          </div>
          <div class="vx-col md:w-1/3 w-full">
            <h5 class="mb-2" style="color: #626262">Product Items</h5>
            <vs-table
              :data="order_formulations_items"
              :hoverFlat="true"
            >

              <template slot="thead">
                <vs-th>Product Order Code</vs-th>
                <vs-th>Selected Quantity (Kg)</vs-th>
                <vs-th>Selected Quantity (Ltr)</vs-th>
              </template>

              <template slot-scope="{data}">
                <vs-tr :data="tr" :key="indextr" v-for="(tr, indextr) in data">
                  <vs-td :data="data[indextr].product_order_code">
                    {{ data[indextr].product_order_code }}
                  </vs-td>
                  <vs-td :data="data[indextr].quantity">
                    {{ toFixed(data[indextr].quantity) }}
                  </vs-td>
                  <vs-td :data="data[indextr].quantity">
                    {{ toFixed(Number(data[indextr].quantity) * Number(selected.formulation_per_lt)) }}
                  </vs-td>
                </vs-tr>
                <vs-tr class="font-semibold">
                  <vs-td>Total</vs-td>
                  <vs-td>{{totalSelectedQuantityKilo}}</vs-td>
                  <vs-td>{{totalSelectedQuantityLiter}}</vs-td>
                </vs-tr>
              </template>
            </vs-table>
            <h5 v-if="is_reblended && re_blend_inventory.length > 0" class="mb-2 mt-8" style="color: #626262">Re-Blend from FG stock</h5>
            <vs-table
              v-if="is_reblended && re_blend_inventory.length > 0"
              :data="re_blend_inventory"
              class="table-dark-inverted table-auto vs-con-loading__container">

              <template slot="thead">
                <vs-th width="15%" class="text-xs">BATCH CODE</vs-th>
                <vs-th width="10%" class="text-xs">QUANTITY (KG)</vs-th>
              </template>

              <template slot-scope="{data}">
                <vs-tr class="text-sm" style="cursor: pointer"  :key="indextr" v-for="(tr, indextr) in data">

                  <vs-td :data="data[indextr].work_order_code">
                    {{ data[indextr].work_order_code}}
                  </vs-td>
                  <vs-td :data="data[indextr].quantity">
                    {{ toFixed(data[indextr].quantity) }}
                  </vs-td>
                </vs-tr>
                <vs-tr class="font-semibold">
                  <vs-td>Total</vs-td>
                  <vs-td>{{toFixed(totalReBlendQuantity)}}</vs-td>
                </vs-tr>
              </template>
            </vs-table>
            <div class="flex flex-wrap items-center justify-end mt-8">
              <h6>Added unallocated stock to this work order (Kg) : {{Number(unallocated_quantity).toFixed(2)}}</h6>
            </div>
            <div class="flex flex-wrap items-center justify-end mt-8">
              <h5>Total quantity to manufature (Kg) : {{totalQuantityToManufacture}}</h5>
            </div>
          </div>
        </div>
        <div class="vx-row mt-4">
          <div class="vx-col w-full">
            <small class="label">Note</small>
            <vs-textarea class="mb-0" v-model="note" height="150px" />
          </div>
        </div>
      </tab-content>

    </form-wizard>
    <work-order-re-blend-pop-up v-on:onAddReBlend="onAddReBlend($event)" ref="workOrderReBlendPopUp"/>
    <assign-formulation-stock-from-work-order-pop-up v-on:refreshData="fetchOrderFormulations" ref="assignFormulationStockFromWorkOrderPopUp"/>
    <work-order-view-rm-stock-pop-up ref="workOrderViewRmStockPopUp"/>
  </vx-card>
</template>

<script>
  import {FormWizard, TabContent} from 'vue-form-wizard'
  import 'vue-form-wizard/dist/vue-form-wizard.min.css'
  import WorkOrderReBlendPopUp from "@/components/popups/manufacturing/work-order/WorkOrderReBlendPopUp.vue"
  import AssignFormulationStockFromWorkOrderPopUp
    from "@/components/popups/manufacturing/formulation-stock/AssignFormulationStockFromWorkOrderPopUp";
  import WorkOrderViewRmStockPopUp from "@/components/popups/manufacturing/work-order/WorkOrderViewRmStockPopUp";
  import {RepositoryFactory} from '@/repository/RepositoryFactory'

  const ManufacturingRepository = RepositoryFactory.get('manufacturing');
  import SuccessMessage from '@/mixins/SuccessMessage'
  import ErrorMessages from '@/mixins/ErrorMessages'
  import Filter from "@/mixins/filter";
  import Utils from "@/mixins/Utils";
  import moment from "moment";
  import vSelect from "vue-select";

  export default {
    name: "WorkOrderViewFormulationSection",
    data() {
      return {
        order_formulations_list: [],
        selected: {},
        order_formulations_items: [],
        production_lines: [],
        selected_production_line: {},
        previous_selected_production_line: {},
        is_exceed: false,
        selected_item_quantity_total: 0,
        total_item_quantity_total: 0,
        note: '',
        unallocated_quantity: 0,
        is_add_unallocated_quantity: false,
        is_reblended: false,
        re_blend_inventory: [],
        filters: {},
        dateSortOrder: 1,
        page : 1,
        total: 0,
        meta : {},
        perPage: 10,
        descriptionItems: [10, 20, 50, 100],
      }
    },
    mixins: [SuccessMessage, ErrorMessages, Filter, Utils],
    components: {
      FormWizard,
      TabContent,
      'v-select': vSelect,
      WorkOrderReBlendPopUp,
      AssignFormulationStockFromWorkOrderPopUp,
      WorkOrderViewRmStockPopUp,
    },
    async mounted() {
      // await this.fetchOrderFormulations();
    },
    methods: {
      filterQueryUpdate (){
        this.page = 1 
        this.fetchOrderFormulations()
      },
      onCLickViewRmStock(id) {
        this.$refs.workOrderViewRmStockPopUp.openPopup(id)
      },
      async formSubmitted() {
        await this.$vs.loading({
          container: '#work-order-create-section',
          scale: 0.45
        });
        try {
          const formulation_order_item_ids = this.order_formulations_items.map((n) => {
            if (Number(n.quantity) > 0) {
              return {id: n.id, quantity: n.quantity.toString()}
            }
          }).filter((n) => {
            return n !== undefined;
          });

          this.total_item_quantity_total = this.order_formulations_items.reduce(function (acc, val) {
            return acc + Number(val.pending_manufacture_quantity);
          }, 0);

          const payload = {
            production_line_id: this.selected_production_line.id,
            formulation_id: this.selected.id,
            formulation_order_item_ids,
            unallocated_quantity: this.unallocated_quantity,
            note: this.note,
            is_reblended: this.is_reblended,
            is_rm_waste_used: false,
            rm_waste_items: [],
          };
          if(this.re_blend_inventory.length > 0) {
            payload.reblended_stock = this.re_blend_inventory.map((n) => {
              return {formulation_stock_inventory_id: n.id, quantity: n.quantity.toString()}
            })
          }
          // unallocated_quantity: Number(this.selected_production_line.max_capacity_kg) -  this.selected_item_quantity_total,
          await ManufacturingRepository.createWorkOrder(payload);
          this.showSuccessMessage('Work order create successfully');
          this.$router.push({path: `/pages/manufacturing/work-orders`})
        } catch (e) {
          this.convertAndNotifyError(e)
        }
        this.$vs.loading.close('#work-order-create-section > .con-vs-loading')

      },
      async handleSelected() {
        const vue = this
        await this.$vs.loading({
          container: '#work-order-create-select-formulation-section',
          scale: 0.45
        });
        const {data} = await ManufacturingRepository.getFormulationsOrderItems(this.selected.id);
        this.order_formulations_items = data.data.map((n) => {
          n.quantity = this.isMaxProductPosibleKiloLessThanTotalOrderQuantity ? 0 : Number(n.pending_manufacture_quantity);
          n.pending_manufacture_quantity = Number(n.pending_manufacture_quantity);
          n.fg_allocation = 0;
          return n
        });
        await this.getProductionLiveLines()

        const formatted_production_lines = this.production_lines.map((n) => {
            n.max_capacity_kg = Number(n.max_capacity_kg)
            n.max_capacity_ltr = Number(n.max_capacity_ltr)
            return n
        })

        if(!this.isMaxProductPosibleKiloLessThanTotalOrderQuantity) {
          const validated_production_lines = formatted_production_lines.sort(function(a, b) {
            return a.max_capacity_kg- b.max_capacity_kg;
          }).filter((n) => {
            return n.max_capacity_kg >= Number(this.selected.total_order_quantity) && n.max_capacity_ltr >= Number(this.selected.total_order_quantity) * Number(this.selected.formulation_per_lt)
          })
          this.selected_production_line = validated_production_lines[0]
          this.previous_selected_production_line = validated_production_lines[0]
        } else {
          const validated_production_lines = formatted_production_lines.sort(function(a, b) {
            return a.max_capacity_kg- b.max_capacity_kg;
          }).filter((n) => {
            return n.max_capacity_kg >= Number(this.selected.max_products_possible) && n.max_capacity_ltr >= Number(this.selected.max_products_possible) * Number(this.selected.formulation_per_lt)
          })
          this.selected_production_line = validated_production_lines[0]
          this.previous_selected_production_line = validated_production_lines[0]
        }

        if(!this.selected_production_line) {
          this.selected_production_line = formatted_production_lines[0]
          this.previous_selected_production_line = formatted_production_lines[0]
          this.order_formulations_items = data.data.map((n) => {
            n.quantity = 0;
            return n
          });
        }

        this.$vs.loading.close('#work-order-create-select-formulation-section > .con-vs-loading')
      },
      handleSelectedProductionLine() {
        const vue = this
        const production_line_total_quantity = Number(this.selected_production_line.max_capacity_kg);
        const production_line_ltr_total_quantity = Number(this.selected_production_line.max_capacity_ltr);
        const total_selected_item_quantity = this.order_formulations_items.filter((m) => !!m.quantity).reduce(function (acc, val) {
          return acc + Number(val.quantity);
        }, 0);
        this.selected_item_quantity_total = total_selected_item_quantity
        const lt_max_capacity = this.selected_item_quantity_total * Number(this.selected.formulation_per_lt)
        if (total_selected_item_quantity > production_line_total_quantity || lt_max_capacity > production_line_ltr_total_quantity) {
          vue.selected_production_line =  vue.previous_selected_production_line
          this.$vs.dialog({
            color: 'danger',
            title: `Warning`,
            text: 'The total quantity of selected items exceeds the maximum capacity of the product line',
            acceptText: 'Confirm'
          })
        } else {
          vue.previous_selected_production_line = vue.selected_production_line
        }
      },
      async getProductionLiveLines() {
        const {data} = await ManufacturingRepository.getLiveProductionLineList(1, 50);
        this.production_lines = data.data.filter((n) => {
          const type = this.selected.formulation_type === 'powder' || this.selected.formulation_type === 'spray dry powder' ? 'powder' :  this.selected.formulation_type
          return n.type === type
        })
      },
      async fetchOrderFormulations() {
        await this.$vs.loading({
          container: '#work-order-create-select-formulation-section',
          scale: 0.45
        });
        try {
          const {data} = await ManufacturingRepository.getFormulationsOrderList(this.filterQuery , `${this.sort || 'shipment-date'}`, this.page, this.perPage);
          this.order_formulations_list = data.data
          this.meta = data.meta
        } catch (e) {
          this.convertAndNotifyError(e)
        }
        this.$vs.loading.close('#work-order-create-select-formulation-section > .con-vs-loading')
      },
      toFixed(number) {
        return Number(number).toFixed(2)
      },
      validateStep1() {
        return new Promise((resolve, reject) => {
          if (!this.selected.id) {
            this.$vs.dialog({
              color: 'danger',
              title: `Warning`,
              text: `Please select a product!`,
              acceptText: 'Close'
            })
            reject("correct all values");
          } else if(!this.selected.formulation_type){
            this.$vs.dialog({
              color: 'danger',
              title: `Warning`,
              text: `Error in record. Formulation type missing!`,
              acceptText: 'Close'
            })
            reject("correct all values");
          } else {
            this.handleSelected()
            resolve(true)
          }
        })
      },
      validateStep2() {
        return new Promise((resolve, reject) => {
          if (this.isMaxProductPosibleKiloLessThanTotalOrderQuantity && Number(this.totalQuantityToManufacture) > Number(this.selected.max_products_possible)) {
            this.$vs.dialog({
              color: 'danger',
              title: `Warning`,
              text: `The total quantity of selected items (${this.totalQuantityToManufacture} Kg) exceeds the max product possible quantity (${this.selected.max_products_possible} Kg)!`,
              acceptText: 'Close'
            })
            reject("correct all values");
          } else if(Number(this.totalQuantityToManufacture) === 0) {
            this.$vs.dialog({
              color: 'danger',
              title: `Warning`,
              text: `The total quantity of manufacturing is 0!`,
              acceptText: 'Close'
            })
            reject("correct all values");
          } else {
            resolve(true)
          }
        })
      },
      onChangeReBlend() {
        try {
          if(this.is_reblended) {
            this.$refs.workOrderReBlendPopUp.openPopup(this.selected)
          }
        }catch (e) {

        }
      },
      onAddReBlend(data) {
        this.re_blend_inventory = data
      },
      handleReBlendStock() {
        this.onInputReBlendInventory(0)
        // if(this.totalReBlendQuantity >)
        // this.re_blend_inventory = this.re_blend_inventory.map((n) => {
        //   n.quantity = 0
        //   return n
        // })
        // this.is_reblended = Number(this.re_blend_inventory.length) > 0
      },
      async onClickStockAssign(data, formulation_id, item_id) {
        this.$refs.assignFormulationStockFromWorkOrderPopUp.openPopup(data, formulation_id, item_id)
        // this.$router.push({path: `/pages/manufacturing/formulation-stock?code=${formulation_code}`})
      },
      checkFgStockAvailable(qty, fg_stock) {
        return Number(qty) <= Number(fg_stock)
      },
      checkFgStockAllocationColumn() {
        return Number(this.totalPendingManufacturingQuantityKilo) <= Number(this.selected.formulation_stock)
      },
      onInputReBlendInventory(index) {
        // this.is_reblended = Number(this.re_blend_inventory.length) > 0
        if (Number(this.totalReBlendQuantity) > Number(this.selected_production_line.max_capacity_kg)) {
          this.re_blend_inventory[index].quantity = Number(this.selected_production_line.max_capacity_kg) - (Number(this.totalReBlendQuantity) - Number(this.re_blend_inventory[index].quantity) )
          this.$vs.dialog({
            color: 'danger',
            title: `Warning`,
            text: `The total quantity of selected items + reblend quantity exceeds the max product possible quantity (${this.selected.max_products_possible} Kg)!`,
            acceptText: 'Close'
          })
        }
        if (Number(this.totalReBlendQuantity) > Number(this.totalSelectedQuantityKilo)) {
          this.re_blend_inventory[index].quantity = Number(this.totalSelectedQuantityKilo) - (Number(this.totalReBlendQuantity) - Number(this.re_blend_inventory[index].quantity) )
          this.$vs.dialog({
            color: 'danger',
            title: `Warning`,
            text: `The total reblend quantity exceeds the selected order quantity (${this.totalSelectedQuantityKilo} Kg)!`,
            acceptText: 'Close'
          })
        }
      },
      checkIfRequestedDate(arr) {
        return this.checkKeyHasOneNotNullValue(arr, 'requested_date')
      },
      sortByDate(){
        this.dateSortOrder = this.dateSortOrder === 1 ? -1 : 1
        this.order_formulations_list = this.order_formulations_list.sort((a,b) => {
          a = moment( a.oldest_item_required_by, "DD/MM/YYYY")
          b = moment( b.oldest_item_required_by, "DD/MM/YYYY")
          let result = 0
          if((a-b) >= 1){
            result = 1
          }if((a-b) <= -1) {
            result = -1
          }
          return result * this.dateSortOrder
        })
      },
      handleSort(key, active) {
        // if(key){
          // active = (active==='desc')? "-":'';
          // this.sort=active+key;
          // this.loadDepartments()
          // this.order_formulations_list = this.order_formulations_list.sort((a, b) => new Date(a.oldest_item_required_by) - new Date(b.oldest_item_required_by))
        // }
        this.page = 1
        if (key){
          active = (active==='desc')? "-":'';
          this.sort=active+key;
          this.fetchOrderFormulations()
        }
      },
      changePage(index) {
        this.page = 1
        this.perPage = this.descriptionItems[index]
      },
      // displayRequiredDate(order_items) {
      //   if(order_items.length > 1) {
      //     return 'multiple'
      //   } else {
      //     return order_items[0].required_by
      //   }
      // }
    },
    computed: {
      totalPendingManufacturingQuantityKilo() {
        const total = this.order_formulations_items.reduce(function (acc, val) {
          return acc + Number(val.pending_manufacture_quantity);
        }, 0);
        return total.toFixed(2)
      },
      totalPendingManufacturingQuantityLiter() {
        const vue = this
        const total = vue.order_formulations_items.reduce(function (acc, val) {
          return acc + Number(val.pending_manufacture_quantity) *  Number(vue.selected.formulation_per_lt);
        }, 0);
        return total.toFixed(2)
      },
      totalSelectedQuantityKilo() {
        const total = this.order_formulations_items.reduce(function (acc, val) {
          return acc + Number(val.quantity);
        }, 0);
        return total.toFixed(2)
      },
      totalSelectedQuantityLiter() {
        const vue = this
        const total = vue.order_formulations_items.reduce(function (acc, val) {
          return acc + Number(val.quantity) *  Number(vue.selected.formulation_per_lt);
        }, 0);
        return total.toFixed(2)
      },
      remainingQuantityKilo() {
        const remaining = Number(this.selected_production_line.max_capacity_kg) - Number(this.totalSelectedQuantityKilo)
        return remaining.toFixed(2)
      },
      remainingQuantityLiter() {
        const remaining = Number(this.selected_production_line.max_capacity_ltr) - Number(this.totalSelectedQuantityLiter)
        return remaining.toFixed(2)
      },
      totalQuantityToManufacture() {
        const total = Number(this.totalSelectedQuantityKilo) + (this.is_add_unallocated_quantity ? Number(this.unallocated_quantity) : 0)
        return Number(total).toFixed(2)
      },
      isMaxProductPosibleKiloLessThanTotalOrderQuantity() {
        return Number(this.selected.total_order_quantity) >= Number(this.selected.max_products_possible)
      },
      remainingProductionLineCapacity() {
        const total = Number(this.selected_production_line.max_capacity_kg) -  Number(this.totalQuantityToManufacture)
        return Number(total).toFixed(2)
      },
      totalReBlendQuantity() {
        const total = this.re_blend_inventory.reduce(function (acc, val) {
          return acc + Number(val.quantity);
        }, 0);
        return total ? Number(total).toFixed(2) : 0
      },
      numberOfSelectedCustomerOrders() {
        let count = 0
        this.order_formulations_items.forEach((n) => {
            if(Number(n.quantity) > 0) {
              count++
            }
        })
        return count
      },
    },
    watch: {
      unallocated_quantity: function () {
        if (Number(this.unallocated_quantity) > Number(this.remainingQuantityKilo)) {
          this.unallocated_quantity = Number(this.remainingQuantityKilo).toFixed(2)
        }
        if(Number(this.unallocated_quantity) < 0) {
          this.unallocated_quantity = 0
        }
      },
      remainingQuantityKilo: function () {
        if (Number(this.unallocated_quantity) > Number(this.remainingQuantityKilo)) {
          this.unallocated_quantity = Number(this.remainingQuantityKilo).toFixed(2)
        }
      },
      totalQuantityToManufacture: {
        handler(newValue, oldValue) {
          if (this.isMaxProductPosibleKiloLessThanTotalOrderQuantity && Number(newValue) > Number(this.selected.max_products_possible)) {
            this.$vs.dialog({
              color: 'danger',
              title: `Warning`,
              text: `The total quantity of selected items (${newValue} Kg) exceeds the max product possible quantity (${this.selected.max_products_possible} Kg)!`,
              acceptText: 'Close'
            })
          }
        },
        deep: true
      },
      // re_blend_inventory: {
      //   handler(newValue, oldValue) {
      //     this.is_reblended = Number(this.re_blend_inventory.length) > 0
      //     if (Number(this.totalReBlendQuantity) > Number(this.remainingQuantityKilo)) {
      //       this.$vs.dialog({
      //         color: 'danger',
      //         title: `Warning`,
      //         text: `The total quantity of selected items + reblend quantity exceeds the max product possible quantity (${this.selected.max_products_possible} Kg)!`,
      //         acceptText: 'Close'
      //       })
      //     }
      //   },
      //   deep: true
      // },
      page(){
        this.fetchOrderFormulations()
      },
      perPage() {
        this.page = 1
        this.fetchOrderFormulations()
      }
    }
  }
</script>

<style scoped>

</style>
